import React, {useState} from 'react';
import * as S from './WalletBalance.styles';
import IconSelector from 'icon-selector/src/icon-selector';

const WalletBalance = ({walletBreakup}) => {
  const host = `${__ENV_CONFIG__.AGENTPROXY_HOST}`;
  const goBack = () => {
    window.location.href = host;
  };

  return (
    <S.WalletWrap>
      <S.BackIconWrap onClick={goBack}>
        <IconSelector iconKey="headerback" />
      </S.BackIconWrap>
      <S.WallectBlc>
        <S.Amount>₹{walletBreakup.wallet_balance}</S.Amount>
        <S.Text>Wallet Balance</S.Text>
      </S.WallectBlc>
    </S.WalletWrap>
  );
};

export default WalletBalance;
